/**
 * @module Footer
 */
import '../../scripts/validation';

import Component from '../base/Component';
import Accordion from '../base/Accordion';
import Field from '../base/Field';
import Checkbox from '../base/Checkbox';
import './styles.css';

import '../CookieNotification';

import '../../images/sprite/logo_pf_full.svg';
import '../../images/sprite/call.svg';
import '../../images/sprite/arrow.svg';
import '../../images/sprite/insta.svg';

/**
 * Название компонента.
 */
export default class Footer extends Component {
    static className = 'footer-main';
}

$(() => {
    const accordionFooter = new Accordion($('.accordion--footer'));
    accordionFooter.init({
        multiple: false,
        breakpoint: 'tablet',
    });

    initSubscribeForm();
    initUnsubscribePopup();
});

function initUnsubscribePopup(){
    const searchParams = new URLSearchParams(window.location.search);
    const searchParamsUnsubscribed = searchParams.get('unsubscribed');
    if(searchParamsUnsubscribed && searchParamsUnsubscribed == 1){
        $('#popup-unsubscribe').addClass('is-open')
    }
}

function initSubscribeForm() {
    const fieldFooter = new Field($('.footer-main__subscribe'));
    fieldFooter.init();

    const checkboxFooter = new Checkbox($('.footer-main__agreement'));
    checkboxFooter.init();

    $('#subscr').on('submit', function(evt) {
        evt.preventDefault();
        $.post(
            '/api/internal/user/subscribe',
            {
                email: $('#field-footer-subscribe').val(),
            },
            message => {
                alert(message);
            }
        );
    });
}
